import React from 'react';
import {
  useTheme,
  useMediaQuery,
  Typography,
  Box,
} from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { AppPaper } from '../../layout/appPaper';
import { AppControlledCheckbox } from '../app/input/appControlledCheckbox';
import { ProfilePreferencesField } from '../../models/preferences';

interface Props {
  exportShowContractType: boolean;
  exportShowProjectManager: boolean;
  onFieldChange: (field: ProfilePreferencesField, value: boolean) => void;
}

export function ExportSettings({
  exportShowContractType,
  exportShowProjectManager,
  onFieldChange,
}: Props): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const methods = useForm({
    defaultValues: {
      [ProfilePreferencesField.EXPORT_SHOW_CONTRACT_TYPE]: exportShowContractType,
      [ProfilePreferencesField.EXPORT_SHOW_PROJECT_MANAGER]: exportShowProjectManager,
    },
  });

  const handleCheckboxChange = (field: ProfilePreferencesField) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onFieldChange(field, event.target.checked);
  };

  return (
    <AppPaper isMobile={isMobile} sx={{ height: '100%' }}>
      <Typography sx={{ mt: 3, mb: 2 }} variant="h4">
        Export Settings
      </Typography>

      <FormProvider {...methods}>
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
          <AppControlledCheckbox
            name={ProfilePreferencesField.EXPORT_SHOW_CONTRACT_TYPE}
            label="Export contract type in Activity detailed"
            defaultValue={exportShowContractType}
            onChangeFn={handleCheckboxChange(ProfilePreferencesField.EXPORT_SHOW_CONTRACT_TYPE)}
          />
          <AppControlledCheckbox
            name={ProfilePreferencesField.EXPORT_SHOW_PROJECT_MANAGER}
            label="Export Project manager in Activity detailed"
            defaultValue={exportShowProjectManager}
            onChangeFn={handleCheckboxChange(ProfilePreferencesField.EXPORT_SHOW_PROJECT_MANAGER)}
          />
        </Box>
      </FormProvider>
    </AppPaper>
  );
}
